export default __webpack_public_path__ + "7d5d7e883db315338384505296f6311f.png";